import { render, staticRenderFns } from "./SpecialSchool.vue?vue&type=template&id=5f7759b4&scoped=true&"
import script from "./SpecialSchool.vue?vue&type=script&lang=js&"
export * from "./SpecialSchool.vue?vue&type=script&lang=js&"
import style0 from "./SpecialSchool.vue?vue&type=style&index=0&id=5f7759b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7759b4",
  null
  
)

export default component.exports